/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useCallback, type FC } from 'react';
import { useLocation } from '@jira/navigation-apps__routing-hooks/src/useLocation.tsx';
import MenuGroup from '@atlaskit/menu/menu-group';
import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';
import { BUTTON } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/action-subject-type.tsx';
import { FIXED_ITEM_BUTTON } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/component-type.tsx';
import { LEVEL_ONE } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/level.tsx';
import { SECTION_ITEM_TEAMS } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/section-type.tsx';
import { MENU_ID_ANALYTIC_EVENT_IDS } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/side-nav.tsx';
import {
	type ConfigurableMenuId,
	L1_MENU_ID,
} from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { useSectionItemAnalytics } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/utils/use-section-item-analytics/index.tsx';
import { useConfigurableMessageAndIconMap } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/controllers/use-configurable-message-and-icon-map/index.tsx';
import { HideL1MenuItemSection } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/hide-l1-menu-item-action/index.tsx';
import { MoreNavMenuButton } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/more-nav-menu-button/main.tsx';
import { MEATBALL_DROPDOWN } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-dashboards/src/common/constants.tsx';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { fg } from '@atlassian/jira-feature-gating';

import type { StubProps } from './types.tsx';

// Note:
export const Stub: FC<StubProps> = ({ menuId, href }) => {
	const { formattedMessage, icon } = useConfigurableMessageAndIconMap(menuId);
	const location = useLocation();

	const path = location.pathname + location.search;
	const sendSectionItemAnalyticsEvent = useSectionItemAnalytics();

	return (
		<LinkMenuItem
			elemBefore={icon}
			href={href}
			isSelected={path === href}
			actionsOnHover={fg('navx-global-side-nav') ? undefined : <ActionButtons menuId={menuId} />}
			onClick={() => {
				if (menuId === L1_MENU_ID.TEAMS) {
					sendSectionItemAnalyticsEvent({
						menuId: L1_MENU_ID.TEAMS,
						sectionItem: SECTION_ITEM_TEAMS,
					});
				}
			}}
		>
			{formattedMessage}
		</LinkMenuItem>
	);
};

type ActionButtonsProps = {
	menuId: ConfigurableMenuId;
};

function ActionButtons({ menuId }: ActionButtonsProps) {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleNavMenuOpen = useCallback(() => {
		fireUIAnalytics(createAnalyticsEvent({}), {
			action: 'clicked',
			actionSubject: BUTTON,
			actionSubjectId: MENU_ID_ANALYTIC_EVENT_IDS[menuId],
			attributes: {
				level: LEVEL_ONE,
				componentType: FIXED_ITEM_BUTTON,
				itemId: MEATBALL_DROPDOWN,
			},
		});
	}, [createAnalyticsEvent, menuId]);

	const MenuItems = useCallback(
		() => (
			<MenuGroup>
				<HideL1MenuItemSection menuId={menuId} hasSeparator={false} />
			</MenuGroup>
		),
		[menuId],
	);

	return <MoreNavMenuButton onOpen={handleNavMenuOpen} MenuItems={MenuItems} />;
}
